<template>
  <div class="home-banner type-banner" :class="{ 'athena-style': theme == 'athena' }">
    <swiper class="swiper" :options="swiperOption" :ref="keys">
      <swiper-slide v-for="list in JSON.parse(products)" :key="list.ID || list.term_taxonomy_id" ref="banner">
        <v-product-card
          :load="load"
          :disable_select="disable_select"
          :show_currency_selector="show_currency_selector"
          :cart_type="cart_type"
          :theme="theme"
          :text_align="text_align"
          :product_price="product_price"
          :card_radio="card_radio"
          card_animate="vogue-am"
          :buy_button_style="buy_button_style"
          :sales_label="sales_label"
          :productDetail="list"
          :sale_image="sale_image"
          :sale_image_show="product_cart_style && product_cart_style.sale_image_show"
          :show_star="show_star"
          :custom_button="list.custom_button && list.custom_button.custom_button"
          model="is_card"
          :palette_config="palette_config"
          :keys="keys"
          combination_position="products"
        ></v-product-card>
      </swiper-slide>
    </swiper>
    <div
      v-if="JSON.parse(products).length >= count"
      class="button-prev d-none d-md-block"
      :class="`button-prev-${keys}`"
      @click="prev"
      ref="prev"
    >
      <span class="swiper-btn-arrow"></span>
    </div>
    <div
      v-if="JSON.parse(products).length >= count"
      class="button-next d-none d-md-block"
      :class="`button-next-${keys}`"
      @click="next"
      ref="next"
    >
      <span class="swiper-btn-arrow"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'disable_select',
    'show_currency_selector',
    'cart_type',
    'theme',
    'text_align',
    'product_price',
    'card_radio',
    'card_animate',
    'buy_button_style',
    'sales_label',
    'products',
    'show_star',
    'sale_image',
    'category_msg',
    'button_text',
    'count',
    'button_url',
    'palette_config',
    'keys',
    'btn_center',
    'product_cart_style',
  ],
  data() {
    return {
      swiperOption: {
        slidesPerView: this.count ? this.count : 5,
        // autoplay: true,
        spaceBetween: 30,
        //Swiper4.x版本为小于
        breakpoints: {
          768: {
            //当屏幕宽度小于等于768
            slidesPerView: 1.6,
            spaceBetween: 15,
          },
        },
        // 点击切换按钮要绑定keys，多个组件的时候，他解析出来的时候还是一个html，所以左右按钮用的同一个类名，就会出现问题
        navigation: {
          nextEl: '.type-banner .button-next-' + this.keys,
          prevEl: '.type-banner .button-prev-' + this.keys,
          disabledClass: 'my-button-disabled',
        },
        noSwipingClass: 'custom-swiper-wrap',
      },
    }
  },
  methods: {
    prev() {
      this.$refs[this.keys].swiper.slidePrev()
    },
    next() {
      this.$refs[this.keys].swiper.slideNext()
    },
    load() {
      if (this.btn_center) {
        let banner_img = this.$(this.$refs.banner[0].$el).find('img')
        if (banner_img && banner_img.length) {
          let top = banner_img.height() / 2
          if (top > 0) {
            top = top + 'px'
            this.$(this.$refs.next).css({ top })
            this.$(this.$refs.prev).css({ top })
          }
        }
      }
    },
  },
  mounted() {
    this.$(window).resize(this.load)
  },
  beforeMount() {},
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs[this.keys].swiper
    },
  },
}
</script>
<style lang="scss">
.home-banner {
  position: relative;
  .swiper {
    overflow: inherit;
  }
  .my-button-disabled {
    display: none !important;
  }

  .swiper-pagination {
    position: unset;
    width: auto !important;
    margin: 15px auto;
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      margin: 0 5px;
    }
    .swiper-pagination-bullet-active {
      transition: width 0.5s;
      width: 34px;
      border-radius: 10px;
      background: #000;
    }
  }
  .swiper-slide {
    .product_item {
      margin-bottom: 0 !important;
    }
  }
  .button-next,
  .button-prev {
    position: absolute;
    // display: flex;
    top: 50%;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    border: 1px solid #d3d4d5;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: rgb(0 0 0 / 25%) 0px 0px 24px 0px;
    .swiper-btn-arrow {
      display: block;
      border-right: 3px solid #212a2f;
      width: 12px;
      height: 12px;
      border-bottom: 3px solid #212a2f;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      top: 50%;
      //   justify-content: center;
      //   align-items: center;
    }
  }

  .button-next {
    right: 10px;
    left: auto;
    .swiper-btn-arrow {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  .button-prev {
    left: 10px;
    right: auto;

    .swiper-btn-arrow {
      transform: translate(-50%, -50%) rotate(135deg);
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 35%;
    height: 35px;
  }
  .swiper-button-prev {
    left: 10px;
  }
  .swiper-button-next {
    right: 10px;
  }
}
@media (max-width: 767px) {
  .home-banner {
    // .swiper-slide {
    //   width: 61% !important;
    // }
    .swiper-button-prev,
    .swiper-button-next {
      height: 22px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
@media (min-width: 768px) {
  .p-md-35 {
    padding: 0 35px;
  }
}
</style>